import { gql } from '@apollo/client'

const FRAGMENT_REQUESTS_FIELDS = gql`
  fragment requestsFields on CaseItem {
    __typename
    id
    created
    caseType
    status
    data {
      __typename
      requestedDevice {
        __typename
        name
      }
      requestedRentCategory {
        __typename
        deviceDefinition {
          __typename
          imageURL
          manufacturer
          codename
          name
          productType
        }
      }
    }
    assignedEmployee {
      __typename
      contact {
        __typename
        firstName
        lastName
      }
    }
    assignedUser {
      __typename
      firstName
      lastName
    }
  }
`

export const GET_ORGANISATION_REQUESTS = gql`
  query getOrganisationRequests(
    $id: ID!
    $first: Int!
    $after: Int!
    $searchterm: String
    $filterByCaseType: [CaseItemType]
  ) {
    organisation(id: $id) {
      id
      caseItems(
        pagination: { after: $after, first: $first }
        searchterm: $searchterm
        orderBy: { field: id, order: DESC }
        filterByCaseType: $filterByCaseType
      ) {
        __typename
        totalCount
        pageInfo {
          __typename
          endCursor
          hasNextPage
        }
        caseItems {
          ...requestsFields
        }
      }
    }
  }
  ${FRAGMENT_REQUESTS_FIELDS}
`
export const GET_EMPLOYEE_REQUESTS = gql`
  query getEmployeeRequests(
    $id: ID!
    $first: Int!
    $after: Int!
    $searchterm: String
    $filterByCaseType: [CaseItemType]
  ) {
    employee(id: $id) {
      id
      caseitems(
        pagination: { after: $after, first: $first }
        searchterm: $searchterm
        orderBy: { field: id, order: DESC }
        filterByCaseType: $filterByCaseType
      ) {
        __typename
        totalCount
        pageInfo {
          __typename
          endCursor
          hasNextPage
        }
        caseItems {
          ...requestsFields
        }
      }
    }
  }
  ${FRAGMENT_REQUESTS_FIELDS}
`
